import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { ContextOrganizationFieldMode } from "components/ContextOrganizationField";
import { MediaLibraryDialogView } from "pages/MediaLibraryPage/MediaLibraryDialogView";
import { useState } from "react";
import { useIntl } from "react-intl";
import { IMediaItem, MediaItemSource } from "services/KnowfullyAdminClient";
import { DeliveryMethodId } from "types/common-types";
import { MediaFilterType, SpecificFormat } from "utils/mediaUtils";

export const mediaItemFormPropsMap = {
  [DeliveryMethodId.Video.toString()]: {
    addButtonLabelKey: "addVideoFile",
    source: MediaItemSource.CourseVideo,
    mediaFilter: SpecificFormat.MP4,
  },
  [DeliveryMethodId.ArticulateRise.toString()]: {
    addButtonLabelKey: "uploadZipFile",
    source: MediaItemSource.ArticulateRise,
    mediaFilter: SpecificFormat.ZIP,
  },
  [DeliveryMethodId.Pdf.toString()]: {
    addButtonLabelKey: "addPdfFile",
    source: MediaItemSource.CoursePdf,
    mediaFilter: SpecificFormat.PDF,
  },
  [DeliveryMethodId.InfographEd.toString()]: {
    addButtonLabelKey: "uploadZipFile",
    source: MediaItemSource.InfographEd,
    mediaFilter: SpecificFormat.ZIP,
  },
  [DeliveryMethodId.ISpring.toString()]: {
    addButtonLabelKey: "uploadZipFile",
    source: MediaItemSource.ISpring,
    mediaFilter: SpecificFormat.ZIP,
  },
};

type SkuDeliveryMediaItemCreateFormProps = {
  addButtonLabelKey: string;
  source: MediaItemSource;
  mediaFilter: MediaFilterType;
  organizationId: string;
  onSubmit: (item: IMediaItem) => void;
  onCancel: () => void;
};
export default function SkuDeliveryMediaItemCreateForm({
  addButtonLabelKey,
  source,
  mediaFilter,
  organizationId,
  onSubmit,
  onCancel,
}: SkuDeliveryMediaItemCreateFormProps) {
  const { formatMessage: t } = useIntl();
  const [dialogOpened, setDialogOpened] = useState(false);

  return (
    <>
      <DialogContent dividers>
        <Button
          startIcon={<CloudUploadIcon />}
          variant="contained"
          onClick={() => setDialogOpened(true)}
        >
          {t({ id: addButtonLabelKey })}
        </Button>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel}>{t({ id: "cancelButton" })}</Button>
      </DialogActions>

      <Dialog
        fullWidth
        maxWidth="lg"
        open={dialogOpened}
        onClose={() => setDialogOpened(false)}
      >
        <DialogContent>
          <MediaLibraryDialogView
            source={source}
            onClickMediaLibraryItem={onSubmit}
            options={[mediaFilter]}
            customBackButtonLabel="backLabel"
            alternativeTextRequired={true}
            customAlternativeTextLabel="displayText"
            organizationPickerMode={ContextOrganizationFieldMode.EditDisabled}
            organizationIdOverride={organizationId}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
